<div class="col-md-12 col-lg-12 p-0 desktop-form-main-login">
  <section *ngIf="showLoader">
    <app-loader></app-loader>
  </section>
</div>



<div *ngIf="!timeDifference && !showLoader">
  <div
    class="col-xs-12 col-md-12 navy-blue header-strip page-heading-strip no-padding background-white mobile-pos-fixed">
    <div class="col-xs-12 col-md-12">
      <h3 class="page-heading">
        <!-- <span class="img-span top-0 cursor-pointer mr-1">
            <img class="back-arrow" src="assets/back-arrow.png">
          </span> -->
        <span class="cursor-pointer">TRANSACTION STATUS</span>
      </h3>
    </div>
  </div>
  <div class="container-fluid main-fix-footer-pad hide-mobile">

    <div class="col-xs-12 col-md-9 col-lg-9 text-center review-bg">

      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 div-center ">
        <img alt="Inprogress" src="assets/img/png/Inprogress.svg" class="payment-failed-icon">
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 div-center">
        <h2 class="payment-heading congratulation">In Progress!</h2>

      </div>

      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding">
        <!-- <div  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-20 payment-label font-bold div-center">
                              InProgress!
                          </div> -->
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-20 bottom-spc-20 payment-label font-bold div-center">
          Verifying your Transaction
        </div>
      </div>
      <!-- <div class="cards d-flex kyc-disclaimer ">
        <img src="../../../assets/icon/Info-icon-kyc.png" class="kyc-icon">
        <span class="kyc-top">{{disclaimer_msg}}</span>
      </div> -->
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 inner-box top-spc-20">
        <div class="col-xs-12 col-md-12 section-spc">
          <div class="col-xs-2 col-md-2 no-pad">
            <div class="shine shimmer-box"></div>
            <!-- <img src="{{aemFragmentInfo?.logo.variations[planCode.toLowerCase() +'_'+ quoteItemDetail.productVariantCode.toLowerCase()]?.value}}"
                                    class="partner-logo" alt="bajaj-finserv-logo"> -->
            <div class="skelt-load loader"></div>
          </div>
          <div class="col-xs-9 col-md-10 no-padding">
            <div class="shimmer-lines shine">
              <!-- {{aemFragmentInfo?.principleName.variations[planCode.toLowerCase() +'_'+ quoteItemDetail.productVariantCode.toLowerCase()]?.value}} -->
            </div>
            <div class="shimmer-lines shine">
              <!-- {{aemFragmentInfo?.productName.variations[planCode.toLowerCase() +'_'+ quoteItemDetail.productVariantCode.toLowerCase()]?.value}} -->
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center top-spc-20">
          <span class="col-xs-6 col-md-6 shimmer-block shine"></span>
          <span class="col-xs-6 col-md-6 amount-Label shimmer-block shine"> </span>

        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label div-center top-spc-20">
          <span class="col-xs-6 col-md-6 shimmer-block shine"></span>
          <span class="col-xs-6 col-md-6 amount-Label shimmer-block shine"> </span>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label div-center top-spc-20">
          <span class="col-xs-6 col-md-6 shimmer-block shine"></span>
          <span class="col-xs-6 col-md-6 amount-Label shimmer-block shine"> </span>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label div-center top-spc-20">
          <span class="col-xs-6 col-md-6 shimmer-block shine"></span>
          <span class="col-xs-6 col-md-6 amount-Label shimmer-block shine"> </span>

        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label  div-center top-spc-12 section-spc">
          <span class="col-xs-6 col-md-6 shimmer-block shine"></span>
          <span class="col-xs-6 col-md-6 amount-Label shimmer-block shine"> </span>
        </div>
        <!-- <div *ngIf="quoteItemDetail && quoteItemDetail.sumassuredamt" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center top-spc-20 section-spc">
                          <span class="col-xs-6 col-md-6">Selected Add-on</span>
                          <span class="col-xs-6 col-md-6 amount-Label" *ngIf="selectedAddons.length > 0">
                            <p  *ngFor="let addon of selectedAddons; let i = index">{{ i !== selectedAddons.length -1 ? addon + ',' : addon}} </p>
                          </span>
                          <span class="col-xs-6 col-md-6 amount-Label" *ngIf="selectedAddons.length < 1">N/A</span>
                        </div> -->

        <!--  <div  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 flex-wraped payment-label top-5 div-center section-spc shimmer-lines shine">
                        <h2 class="choose-product-heading shimmer-lines shine"></h2>
                          <span class="col-xs-6 col-md-6 shimmer-block shine"></span>
                          <span class="col-xs-6 col-md-6 policyNum shimmer-block shine">
                            <div>
                              <div *ngFor="let policyDownloadResponse of policyDownloadResponseList; let i = index">
                                <div *ngIf="policyDownloadResponse.policyNumber"
                                  [ngClass]="i === 0 ? bottom-margin-20 : ''">
                                    <h5 class="text-center font15">
                                    
                                      <div>{{policyDownloadResponse.policyNumber}}
                                        <span class="icon icon-Bajaj_Icon_Cybersafe_01_download"
                                          (click)="DownloadPolicy(policyDownloadResponse)"></span>
                                      </div>
                                    </h5>
                                </div>
                              </div>
                            </div> 
                          </span>
                        </div>-->
        <!-- <div *ngIf="quoteItemDetail && quoteItemDetail.addon" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center top-spc-20">
                            <span class="col-xs-6 col-md-6">Selected Add-on</span>
                            <span class="col-xs-6 col-md-6 amount-Label">N/A</span>
                        </div> -->
        <!-- <div *ngIf="quoteDetail && quoteDetail.grossPremiumAmount" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
                            <span class="col-xs-6 col-md-6">Total Premium</span>
                            <span class="col-xs-6 col-md-6 amount-Label"> ₹{{formatter.ToCurrency(quoteDetail.grossPremiumAmount.toString())}}</span>
                        </div> -->
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center">
                          <span class="col-xs-6 col-md-6">Payment Mode</span>
                          <span class="col-xs-6 col-md-6 amount-Label"> N/A</span>
                        </div> -->
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-40 margin-btm-20" *ngIf="!CongratulationScreen && principalCode === 'BAGIC'">
                          <button id="btnCongratulationExploare" class="btn btn-primary btn-block btnconfirm top-spc-50 btn-single fixed" (click)="Next()">
                            PROCEED
                          </button>
                        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-40 margin-btm-20">
          <div class="shine shimmer-befinit-row"></div>
        </div>
      </div>
    </div>
  </div>
  <section class="col main-content p-md-0 no-pad hide-desktop">
    <div class="flex-container col-md-12 no-pad">
      <div class="flex-item no-border-radius flex-error-item">
        <div class="col-md-12 error-section d-flex ">
          <div class="col-xs-3 col-4 col-md-3 center">
            <img alt="Inprogress" style="height: 70px" class="vehicles-logo" src="assets/img/png/Inprogress.svg">
          </div>
          <div class="col-md-9 col-9">
            <h2 class="mb-05 error-label">In Progress!</h2>
            <p class="payment-desc">Verifying your Transaction</p>
          </div>

        </div>
        <!-- <div class="col-md-12 transaction-msg shimmer-lines shine">
                            
                            </div> -->
      </div>

      <!-- <div class="flex-item no-border-radius flex-error-item" >
                            <div class="col-md-12 rating-section shimmer-lines shine">
                            
                            
                              <div class="text-center shimmer-lines shine">
                              
                                <div class="text-center shimmer-lines shine">
                                
                                </div>
                                <h2 class="rate-us-lable cursor-pointer bottom-spc-10">RATE US NOW
                                    <i class="icon-spec-value icon-a_downward_arrow hightlight-color cursor-pointer details-dropdown"></i>
                                </h2>
                              </div>
                            </div> -->

      <div class="flex-item no-border-radius flex-error-item">

        <div class="dark-blue card-object">
          <div class="card-object-header1">
            <div class="col-xs-12 col-md-9 no-pad">
              <div class="col-xs-2 col-md-2 no-pad">
                <div class="shine shimmer-box"></div>
                <!-- <img src="{{aemFragmentInfo?.logo.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value}}"
                                              class="partner-logo" alt="bajaj-finserv-logo" (load)="isLogoLoaded(aemFragmentInfo?.cardColour.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value , i)" [hidden]="!isPartnerLogoLoaded"> 
                                          <div class="skelt-load loader" ></div>-->
              </div>
              <div class="col-xs-9 col-md-10 right0 pad0-mobile pt-m">
                <div class="shimmer-lines shine">

                </div>
                <div class="shimmer-lines shine">

                </div>
              </div>
            </div>
            <!-- <div class="col-xs-6 col-md-3 padnon mob-right float-right" *ngIf="tags">
                                      <div class="ribbon-container">
                                        <span class="pointy">{{tags}}</span>
                                      </div>
                                  </div> -->
          </div>
          <div class="card-object-body">
            <div class="approval-box no-padding">
              <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                <div class="col-md-12 col-sm-12 col-xs-12 pad-0">


                  <div class="pad0-mobile top-spc-10 bottom-spc-10  pad-0 col-md-4 col-sm-4 col-xs-4">
                    <div class="col-xs-12 pad0-mobile ">
                      <span class="text-center plan-sub-desc shimmer-lines shine">

                      </span>
                    </div>
                    <div class="col-xs-12 pad0-mobile ">
                      <label class="plan-sub-head shimmer-lines shine"></label>
                    </div>
                  </div>

                  <div class="pad0-mobile top-spc-10 bottom-spc-10  pad-0 col-md-4 col-sm-4 col-xs-4">
                    <div class="col-xs-12 pad0-mobile ">
                      <span class="text-center plan-sub-desc shimmer-lines shine">

                      </span>
                    </div>
                    <div class="col-xs-12 pad0-mobile ">
                      <label class="plan-sub-head shimmer-lines shine"></label>
                    </div>
                  </div>
                  <div class="pad0-mobile top-spc-10 bottom-spc-10  pad-0 col-md-4 col-sm-4 col-xs-4">
                    <div class="col-xs-12 pad0-mobile ">
                      <span class="text-center plan-sub-desc shimmer-lines shine">

                      </span>
                    </div>
                    <div class="col-xs-12 pad0-mobile ">
                      <label class="plan-sub-head shimmer-lines shine"></label>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>

        <ng-container>
          <div class="col-md-12 error-section pad-top-bottom-1 d-flex justify-content-between mt-10">
            <h2 class="mb-05 instapack-label shimmer-lines shine"></h2>
          </div>
          <div class="col-md-12 transaction-msg">
            <p class="instapack-desc shimmer-lines shine"> <span class="flt-rght">
                <!-- {{ policyDownloadResponse.policyNumber }} -->

                <div>
                  <div>
                    <h5 class="text-center font15 word-break">
                      <!-- {{ policyDownloadResponse.title }}<strong>:</strong> -->
                      <div shimmer-lines shine>
                        <!-- <span class="icon icon-Bajaj_Icon_Cybersafe_01_download"
                                                (click)="DownloadPolicy(policyDownloadResponse)"></span> -->
                      </div>
                    </h5>
                  </div>
                </div>
              </span></p>
          </div>
        </ng-container>
        <!-- <div class="cards d-flex kyc-disclaimer-mobile ">
          <img src="../../../assets/icon/Info-icon-kyc.png" class="kyc-icon-mobile">
          <span class="kyc-top-mobile">{{disclaimer_msg}}</span>
        </div> -->



      </div>

      <div class="flex-item no-border-radius flex-error-item">
        <h2 class="choose-product-heading shimmer-lines shine"></h2>

        <ng-container>
          <div class="col-md-12 rating-section">
            <h2 class="mb-05 rating-label shimmer-lines shine">
              <!-- <span class="flt-rght cursor-pointer" >
                                    <img  class="vehicles-logo light-icon-display" src="assets/img/png/download_icon.png">
                                    <img  class="vehicles-logo dark-icon-display" src="assets/img/png/download-dark.png">
                                </span> -->
            </h2>
          </div>
        </ng-container>


      </div>

      <div class="flex-item no-border-radius flex-error-item pad-bottom-70">
        <h2 class="choose-product-heading">People like you also bought <span class="badge">04</span></h2>
        <div class="col-md-12 rating-section1 p-0">
          <!-- <img  class="people-scroll-img" src="assets/img/jpeg/banner-15@2x.jpg"> -->
          <carousel [interval]="4000" [noPause]="true" class="loan-details-container home-slider">
            <ng-container *ngIf="finalBannerAemArray.length > 0">
              <ng-container *ngFor="let imageAem of finalBannerAemArray">
                <slide>
                  <a href="{{imageAem?.redirectionURL}}" target="_blank">
                    <img alt="banner" src="{{imageAem?.imageIcon}}"
                      onerror="this.onerror=null;this.src='assets/img/png/bajajLogo-placeholder.png'"
                      style="display: block; width: 100%; height: 100%;">
                  </a>
                </slide>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="finalBannerAemArray.length==0">
              <slide>
                <a href="https://www.bajajfinservmarkets.in/apply-for-personal-loan/" target="_blank">
                  <img alt="banner" src="assets/img/png/bajajLogo-placeholder.png"
                    style="display: block; width: 100%; height: 100%;">
                </a>
              </slide>
            </ng-container>
          </carousel>
        </div>
      </div>


      <!-- <div class="btn-fix-container">
                  
                              <button type="button" *ngIf="!CongratulationScreen && principalCode === 'BAGIC'" class="btn btn-primary btnconfirm btn-single pad0"
                                  (click)="Next()">
                                  PROCEED
                              </button>
                  
                              <button type="button" *ngIf="CongratulationScreen" class="btn btn-primary btnconfirm btn-single pad0"
                                  (click)="ExploreMore()">
                                  EXPLORE MORE
                              </button>
                            </div> -->


    </div>
  </section>
</div>

<app-congratulations-component *ngIf="timeDifference" [timeDifference]="timeDifference" [summaryData]="summaryData"
  [PaymentDetails]="PaymentDetails">
</app-congratulations-component>